// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const webViewUserAgent = 'NusantaraWebViewApp';
export const regexNumbers = /^[0-9\b]+$/;
